import { Card, Button, Typography, Space, Divider, message } from 'antd';
import React, { useState, useEffect } from 'react';

import { bankApi } from '../services/api';

const { Title, Text, Paragraph } = Typography;

const DebugTokenPage: React.FC = () => {
  const [tokenInfo, setTokenInfo] = useState<any>({});
  const [apiTestResult, setApiTestResult] = useState<string>('');

  useEffect(() => {
    checkTokens();
  }, []);

  const checkTokens = () => {
    const info = {
      localStorage_token: localStorage.getItem('token'),
      localStorage_accessToken: localStorage.getItem('accessToken'),
      sessionStorage_token: sessionStorage.getItem('token'),
      sessionStorage_accessToken: sessionStorage.getItem('accessToken'),
      rememberMe: localStorage.getItem('rememberMe'),
      selectedDatabaseId: localStorage.getItem('selectedDatabaseId'),
      currentPath: window.location.pathname,
    };
    setTokenInfo(info);
  };

  const testApiCall = async () => {
    try {
      setApiTestResult('API çağrısı yapılıyor...');
      const response = await bankApi.getBankTransactionReport({
        page: 1,
        pageSize: 5,
        startDate: '20250623',
        endDate: '20250723'
      });
      setApiTestResult(`✅ Başarılı: ${JSON.stringify(response, null, 2)}`);
    } catch (error: any) {
      setApiTestResult(`❌ Hata: ${error.message}\n${JSON.stringify(error.response?.data || error, null, 2)}`);
    }
  };

  const clearAllTokens = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('accessToken');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('accessToken');
    message.success('Tüm token\'lar temizlendi');
    checkTokens();
  };

  const setTestToken = () => {
    const testToken = 'test-token-123';
    localStorage.setItem('token', testToken);
    message.success('Test token eklendi');
    checkTokens();
  };

  return (
    <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
      <Title level={2}>Token Debug Sayfası</Title>
      
      <Card title="Token Durumu" style={{ marginBottom: '16px' }}>
        <Space direction="vertical" style={{ width: '100%' }}>
          {Object.entries(tokenInfo).map(([key, value]) => (
            <div key={key}>
              <Text strong>{key}:</Text> 
              <Text code style={{ marginLeft: '8px' }}>
                {value ? (typeof value === 'string' && value.length > 50 ? 
                  `${value.substring(0, 20)}...${value.substring(value.length - 10)}` : 
                  String(value)) : 'null'}
              </Text>
            </div>
          ))}
        </Space>
        
        <Divider />
        
        <Space>
          <Button onClick={checkTokens}>Yenile</Button>
          <Button onClick={clearAllTokens} danger>Tüm Token'ları Temizle</Button>
          <Button onClick={setTestToken} type="dashed">Test Token Ekle</Button>
        </Space>
      </Card>

      <Card title="API Test">
        <Space direction="vertical" style={{ width: '100%' }}>
          <Button type="primary" onClick={testApiCall}>
            Bank Transaction API Test
          </Button>
          
          {apiTestResult && (
            <div>
              <Text strong>Sonuç:</Text>
              <Paragraph>
                <pre style={{ 
                  background: '#f5f5f5', 
                  padding: '12px', 
                  borderRadius: '4px',
                  fontSize: '12px',
                  maxHeight: '400px',
                  overflow: 'auto'
                }}>
                  {apiTestResult}
                </pre>
              </Paragraph>
            </div>
          )}
        </Space>
      </Card>
    </div>
  );
};

export default DebugTokenPage;